import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { LogoFull } from '../components/Logo';

export default function VerifyEmail() {
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token found. Please use the link from your email.');
      return;
    }
    api.auth.verify(token)
      .then(() => setStatus('success'))
      .catch(err => {
        setStatus('error');
        setMessage(err.message || 'Verification failed. The link may have expired.');
      });
  }, []);

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div className="auth-logo"><LogoFull iconSize={64} /></div>

        {status === 'verifying' && (
          <>
            <div style={{ margin: '16px 0' }}><span className="spinner" style={{ width: 32, height: 32, borderWidth: 3 }}></span></div>
            <h1 className="auth-title">Verifying your email...</h1>
            <p style={{ color: 'var(--muted)', fontSize: 14 }}>Please wait a moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 48, color: 'var(--success)', margin: '16px 0' }}>&#10003;</div>
            <h1 className="auth-title">Email verified!</h1>
            <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.7, marginBottom: 32 }}>
              Your email has been verified. You can now sign in.
            </p>
            <Link to="/login" className="btn btn-primary" style={{ textDecoration: 'none', justifyContent: 'center' }}>
              Sign in
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 48, color: 'var(--danger)', margin: '16px 0' }}>&#10007;</div>
            <h1 className="auth-title">Verification failed</h1>
            <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.7, marginBottom: 24 }}>{message}</p>
            <Link to="/resend-verification" style={{ color: 'var(--accent)', fontSize: 14, display: 'block', marginBottom: 16 }}>
              Request a new verification link
            </Link>
            <Link to="/login" style={{ color: 'var(--muted)', fontSize: 13 }}>Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
